import {createContext} from 'react';

const FABContext = createContext<boolean>(true);

export default FABContext;
